import { createContext, useContext } from 'react';

const GoogleApiContext = createContext({});

const GoogleApiContextConsumer = GoogleApiContext.Consumer;
const GoogleApiContextProvider = GoogleApiContext.Provider;
const useGoogleApiContext = () => useContext(GoogleApiContext);

export { GoogleApiContextProvider, GoogleApiContextConsumer, useGoogleApiContext };
